import { X } from 'lucide-react'
import PostEditor from './PostEditor'
import type { Post } from '../types'

interface PostFormModalProps {
  isOpen: boolean
  onClose: () => void
  tripId?: string
  eventId?: string
  onSuccess?: () => void
  mode?: 'create' | 'edit'
  post?: Post | null
}

export default function PostFormModal({
  isOpen,
  onClose,
  tripId,
  eventId,
  onSuccess,
  mode = 'create',
  post = null,
}: PostFormModalProps) {
  if (!isOpen) return null

  const handleSuccess = (postId: string) => {
    console.log(mode === 'edit' ? 'Post updated:' : 'Post created:', postId)
    onSuccess?.()
    onClose()
  }

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        {/* Background overlay */}
        <div 
          className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" 
          onClick={onClose}
        />

        {/* Modal panel */}
        <div className="inline-block w-full max-w-4xl my-8 overflow-hidden text-left align-middle transition-all transform bg-white rounded-lg shadow-xl">
          {/* Header */}
          <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
            <h2 className="text-xl font-semibold text-gray-900">
              {mode === 'edit' ? 'Edit Post' : 'Create Post'}
              {tripId && <span className="ml-2 text-sm text-gray-500">(in trip)</span>}
              {eventId && <span className="ml-2 text-sm text-gray-500">(in event)</span>}
            </h2>
            <button
              onClick={onClose}
              className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          {/* Content */}
          <div className="px-6 py-6 max-h-[calc(100vh-200px)] overflow-y-auto">
            <PostEditor
              tripId={tripId}
              eventId={eventId}
              onSuccess={handleSuccess}
              onCancel={onClose}
              mode={mode}
              postId={post?.id}
              existingPost={post || undefined}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
